import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { get } from 'global/lib/lodash';
import { userHasPermissions, userHasAtLeastOnePermission } from 'redux/actions/userLogin';
import useNavSettings from '../../hooks/useNavSettings';

export default (Component) => (props) => {
  const { requiredNav } = props;
  const { nav } = useNavSettings();
  // PFM-2641: an anonymous hash (share-link) viewer has no nav/permissions, so
  // the standard gate would alert + bounce them to /home -> login. While a hash
  // session is active we skip the redirect; HashViewGuard already pins the viewer
  // to the shared content. Mirrors how useAccessRedirect special-cases hash sessions.
  const hashViewHasToken = useSelector((s) => !!s?.hashAuth?.hashToken);

  useEffect(() => {
    if (hashViewHasToken) return;
    const allowedPermissions = get(props, 'allowedPermissions');
    if (!userHasPermissions(allowedPermissions)) {
      alert('You do not have permission to be here. Redirecting you home.');
      window.location.href = '/home';
    }
  }, [props.allowedPermissions, hashViewHasToken]);

  useEffect(() => {
    if (hashViewHasToken) return;
    if (requiredNav && !get(nav, requiredNav)) {
      alert('You do not have permission to be here. Redirecting you home.');
      window.location.href = '/home';
    }
  }, [nav, requiredNav, hashViewHasToken]);

  return <Component {...props} />;
};

export const PermissionControlledDisplay = (Component) => {
  return function PermissionWrapper(props) {
    const { allowedPermissions, ...rest } = props;
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
      if (userHasAtLeastOnePermission(allowedPermissions)) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    }, [allowedPermissions]);

    return isVisible ? <Component {...rest} /> : null;
  };
};